import React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

export default function ConfirmDialog (props) {
  const handleCancel = React.useCallback(event => {
    event.stopPropagation()
    props.onCancel()
  }, [props])

  const handleConfirm = React.useCallback(event => {
    event.stopPropagation()
    props.onConfirm()
  }, [props])

  return (
    <Dialog
      data-testid={props['data-testid']}
      open={props.open}
      onClose={handleCancel}
      maxWidth='xl'
    >
      <DialogTitle
        data-testid='label-title'
      >{props.title}</DialogTitle>

      <DialogContent>
        <DialogContentText
          data-testid='label-text'
        >{props.text}</DialogContentText>
        <DialogContentText
          sx={{ fontWeight: 'bold', whiteSpace: 'pre-wrap', marginTop: '10px' }}
          data-testid='label-boldtext'
        >{props.boldText}</DialogContentText>

      </DialogContent>

      <DialogActions>
        <Button
          data-testid='button-cancel'
          variant='outlined'
          onClick={handleCancel}
        >Cancel</Button>

        <Button
          data-testid='button-confirm'
          autoFocus
          variant='contained'
          onClick={handleConfirm}
        >Confirm</Button>
      </DialogActions>
    </Dialog>
  )
}
